import {SHOW_CLOSE_MODAL_CONFIRMATION, SET_CLOSE_MODAL_CONFIRMATION_CONFIRM_CB} from '../constants/constants'
const modalsInitialState = {
    confirmModal: {
        confirmCb: null,
        showModal: false
    }
}

export const modalState=(state=modalsInitialState, action={})=>{
    if(action.type===SHOW_CLOSE_MODAL_CONFIRMATION){
        return {...state, confirmModal: {...state.confirmModal, showModal: action.payload}}
    } else if(action.type===SET_CLOSE_MODAL_CONFIRMATION_CONFIRM_CB) {
        return {...state, confirmModal: {...state.confirmModal, confirmCb: action.payload}}
    }
    return state
}